import DemandeReAdmission from '../views/DemandeAdmissionReAdmission.vue'
import RenseignementsGeneraux from '../components/DemandeAdmissionReAdmission/RenseignementsGeneraux.vue'
import AutorisationDePratique from '../components/DemandeAdmissionReAdmission/AutorisationDePratique.vue'
import DeclarationsObligatoires from '../components/DemandeAdmissionReAdmission/DeclarationsObligatoires.vue'
import AttestationVeracite from '../components/DemandeAdmissionReAdmission/AttestationVeracite.vue'
import InformationsComplementaires from '../components/DemandeAdmissionReAdmission/InformationsComplementaires.vue'
import AutresAutorisationsDePratique from '../components/DemandeAdmissionReAdmission/AutresAutorisationsDePratique.vue'
import Langues from '../components/DemandeAdmissionReAdmission/Langues.vue'
import ExperienceDeTravail from '../components/DemandeAdmissionReAdmission/ExperienceDeTravail.vue'

const routeName = "DemandeAdmissionReAdmission"

export default [
  {
    path: '/demande-admission/readmission',
    component: DemandeReAdmission,
    meta: {
      title: 'Demande ré-admission | OTSTCFQ'
    },
    props: {
      isReAdmission: true,
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "langues",
        name: `${routeName}/Langues`,
        component: Langues
      },
      {
        path: "experience-de-travail",
        name: `${routeName}/ExperienceDeTravail`,
        component: ExperienceDeTravail
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires
      },
      {
        path: "attestation-veracite",
        name: `${routeName}/AttestationVeracite`,
        component: AttestationVeracite
      },
      {
        path: "autres-autorisations-de-pratique",
        name: `${routeName}/AutresAutorisationsDePratique`,
        component: AutresAutorisationsDePratique
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique
      },
      {
        path: "informations-complementaires",
        name: `${routeName}/InformationsComplementaires`,
        component: InformationsComplementaires
      }
    ]
  }
]